export interface InventoryListing {
  id: number;
  label?: string;
  order_ids?: number[];
  customer_id?: number;
  customer_name?: string;
  has_coupon?: boolean;
  has_onelink?: boolean;
  redemption_code_global?: string;
  is_master?: boolean;
  active?: boolean;
  created_date: string;
  modified_date: string;
}

export const InventoryTypeOptions = [
  { id: "-1", value: "Select Inventory Type" },
  { id: "1", value: "Master" },
  { id: "2", value: "Order Level" },
];
